import React, { useState, useEffect } from "react";
import { Grid, Button, Typography } from "@material-ui/core";
import axios from "axios";
import wp from "./ourTeam.png";
import svcDelhi from "./svcDelhi.jpg";
import VNIT from "./VNIT_logo.jpeg";
import IITB from "./IITB.svg";
import DTU from "./DTU.jpg";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DSC from "./DSC.jpg";
import { Carousel } from "3d-react-carousal";
import { Link, useHistory } from "react-router-dom";
import Footer from "../About/Footer";
import ImageSetup from "./ImageSetup";
import { GET_B1, GET_B2, GET_B3 } from "../../api/mainPage";
import Insights from "../Insights";
import ConnectWithUs from "../ContactWithUs";
import Spotlight from "../Spotlight";
import Form from "../Form";
import MarkoknowFAQ from "../FAQ";
import Numbers from "../Numbers";
import RealOutcomes from "../RealOutcomes";
import MembershipStages from "../MembershipStages";
import Typewriter from "typewriter-effect";

// Import CSS
import "./NewHome.css";

function NewHome({ isAuth }) {
  const navigate = useHistory();
  const newlist = [svcDelhi, VNIT, IITB, DTU, DSC];

  // State hooks (Kept from original logic)
  const [road1, setRoad1] = useState(false);
  const [road2, setRoad2] = useState(false);
  const [road3, setRoad3] = useState(false);
  const [road4, setRoad4] = useState(false);
  const [road5, setRoad5] = useState(false);

  const [b1, setB1] = useState(null);
  const [b2, setB2] = useState(null);
  const [b3, setB3] = useState(null);
  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("md"));

  const getB1 = () => {
    axios.get(GET_B1).then((res) => { setB1(res.data); }).catch((err) => console.error(err));
  };
  const getB2 = () => {
    axios.get(GET_B2).then((res) => { setB2(res.data); }).catch((err) => console.error(err));
  };
  const getB3 = () => {
    axios.get(GET_B3).then((res) => { setB3(res.data); }).catch((err) => console.error(err));
  };

  useEffect(() => {
    getB1();
    getB2();
    getB3();
  }, []);

  const statistics = [
    { number: 50000, label: "Community of Founders, Investors & Learners" },
    { number: 200, label: "Hours Committed To Innovation & Social Cause" },
    { number: 46, label: "City Presence Across India For Enablement" },
    { number: 34, label: "Corporates & Universities Associated" },
  ];

  return (
    <>
      {/* --- 1. HERO SECTION --- */}
      <div className="nh-body">
        <div className="nh-container">
          <Grid container spacing={4} alignItems="center">
            <Grid item lg={6} md={6} xs={12}>

              <Typography className="nh-heading-main">
                Platform for{" "}
                <span className="nh-text-accent" style={{ display: "inline-block" }}>
                  <Typewriter
                    options={{
                      strings: ["Startups", "Enthusiasts", "Founders", "Investors"],
                      autoStart: true,
                      loop: true,
                      delay: 50,
                      deleteSpeed: 30,
                    }}
                  />
                </span>{" "}
                to Connect and Grow
              </Typography>

              <Typography className="nh-subheading">
                {b1?.subTitle || "50,000+ member platform for Startups and Enthusiasts to grow, network and work towards their startup"}
              </Typography>

              <div className="nh-hero-actions">
                <Link to={"/login"} style={{ textDecoration: "none" }}>
                  <Button variant="contained" className="nh-btn-explore">
                    Explore More
                  </Button>
                </Link>

                <div className="nh-hero-connect">
                  <ConnectWithUs />
                </div>
              </div>
            </Grid>

            <Grid item lg={6} md={6} xs={12} className="nh-hero-image-wrapper">
              <ImageSetup />
            </Grid>
          </Grid>
        </div>
      </div>

      {/* --- 2. OUR COMMUNITY (FLIP CARDS) --- */}
      <div className="nh-section-light nh-py-xl">
        <Typography className="nh-heading-center">
          Our Community
        </Typography>

        <Grid container spacing={2} className="nh-community-grid">
          {[
            {
              num: "01", head: "Founder's Network", desc: "Add Founders in your Startup Journey Network",
              color: "#b1a6e9", textColor: "#221857"
            },
            {
              num: "02", head: "Learn From Founders", desc: "Learn about Startups from people who have done it",
              color: "#89e3db", textColor: "#004d40"
            },
            {
              num: "03", head: "Get Mentored", desc: "Get a guidance throughout your journey",
              color: "#001a33", textColor: "#ffffff"
            },
            {
              num: "04", head: "Funded & Revenue", desc: "Get help to start fundraising or start bootstrapping",
              color: "#002856", textColor: "#ffffff"
            }
          ].map((card, index) => (
            <Grid item lg={3} md={6} xs={12} key={index} className="nh-flip-card-wrapper">
              <div className="nh-flip-card">
                <div className="nh-flip-card-inner">

                  {/* FRONT */}
                  <div className="nh-flip-card-side nh-flip-card-front" style={{ backgroundColor: card.color }}>
                    <Typography className="nh-card-text-flip" style={{ color: card.textColor }}>
                      {card.num}
                    </Typography>
                    <Typography className="nh-card-text-flip nh-card-text-flip-title" style={{ color: card.textColor }}>
                      {card.head}
                    </Typography>
                  </div>

                  {/* BACK */}
                  <div className="nh-flip-card-side nh-flip-card-back" style={{ backgroundColor: card.color === "#b1a6e9" ? "#b1a6e9" : card.color }}>
                    <Typography className="nh-desc-text-flip" style={{ color: card.textColor }}>
                      {card.desc}
                    </Typography>
                  </div>

                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>

      {/* --- 3. TECHNOLOGY DRIVEN GROWTH --- */}
      <div className="nh-dark-section">
        <div className="nh-container">
          <Grid container spacing={4} alignItems="center">
            <Grid item lg={6} md={12} xs={12}>
              <Typography className="nh-heading-white">
                Technology Driven Growth
              </Typography>
              <Typography className="nh-text-modern">
                Supporting the aim to create an efficient ecosystem, we are
                backing technology startups driven on latest tech and trends.
                Our Focus Industry areas are designed to push limits.
              </Typography>
            </Grid>

            <Grid item lg={6} md={12} xs={12}>
              <ul className="nh-list-modern">
                <li><span>✔</span> Guided Mode On</li>
                <li><span>✔</span> Founders To help you</li>
                <li><span>✔</span> Make your startup work for you</li>
                <li><span>✔</span> Get clarity of major issues surfacing</li>
              </ul>
            </Grid>
          </Grid>
        </div>
      </div>

      {/* --- 4. REAL OUTCOMES --- */}
      <RealOutcomes />

      {/* --- 5. MEMBERSHIP STAGES --- */}
      <MembershipStages />

      {/* --- 6. INSIGHTS --- */}
      <div className="nh-section-light nh-py-large">
        <Insights />
      </div>

      {/* --- 5. NUMBERS --- */}
      <Numbers
        statistics={statistics}
        backgroundColor="#f8fafc"
        textColor="#001a33"
        accentColor="#5a4bce"
        duration={2000}
      />

      {/* --- 6. OUR TEAM --- */}
      <div className="nh-dark-section">
        <div className="nh-container">
          <Grid container spacing={6} alignItems="center">
            <Grid item lg={5} md={12} xs={12}>
              <img src={wp} className="nh-team-image" alt="Our Team" />
            </Grid>
            <Grid item lg={7} md={12} xs={12}>
              <Typography className="nh-heading-white">
                Our Team at Markoknow
              </Typography>
              <Typography className="nh-text-modern">
                We are a group of enthusiastic people who envision a future of
                growth. We are leading the stepping stone for innovative startup
                building that could map us as a world leader in innovation and
                growth. With an aligned vision, we are building ideas and leading
                them towards milestone achievements.
              </Typography>
            </Grid>
          </Grid>
        </div>
      </div>

      {/* --- 7. SPOTLIGHT --- */}
      <div className="nh-section-light nh-py-xl">
        <Spotlight />
      </div>

      {/* --- 8. SESSIONS CAROUSEL --- */}
      <div className="nh-section-blue nh-py-large">
        <Typography variant="h3" className="nh-carousel-title">
          Our Sessions At
        </Typography>

        <div className="nh-carousel-container">
          <div className="nh-carousel-inner">
            {newlist.length > 0 && (
              <Carousel
                slides={newlist.map((item, index) => (
                  <div key={index} className="nh-carousel-slide">
                    <img src={item} alt={`Session ${index}`} className="nh-carousel-img" />
                  </div>
                ))}
                autoplay={true}
                interval={3000}
                animation={"slide"}
              />
            )}
          </div>
        </div>
      </div>

      {/* --- 9. FAQ & FORM --- */}
      <div className="nh-section-light nh-py-medium">
        <MarkoknowFAQ />
      </div>

      <div className="nh-form-wrapper">
        <Form open={true} onClose={""} category={"Contact - Main Page"} type="" />
      </div>

      <Footer />
    </>
  );
}

export default NewHome;

{/* <div className={classes.body2}>
  <div className={classes.container}>
    <div className={classes.heading}>Numbers That Keep Growing</div>
    <Grid container spacing={3}>
    <Grid item lg={4} xs={12}>
    <div className={classes.cardHeading}>
    <CountUp
    end={50000}
    enableScrollSpy={true}
    scrollSpyOnce={false}
    scrollSpyDelay={0}
    duration={3}
    />
    +
    </div>
    <div className={classes.cardsubHeading}>{b3?.title1}</div>
    
    <Grid style={{ fontWeight: "bold" }}>{b3?.desc1}</Grid>
          </Grid>
          <Grid item lg={4} xs={12}>
          <div className={classes.cardHeading}>
          <CountUp
          end={170}
            enableScrollSpy={true}
            scrollSpyOnce={false}
            scrollSpyDelay={0}
            duration={4}
            />
            +
          </div>
          <div className={classes.cardsubHeading}>{b3?.title2}</div>
          <Grid style={{ fontWeight: "bold" }}>{b3?.desc2}</Grid>
        </Grid>
        <Grid item lg={4} xs={12}>
        <div className={classes.cardHeading}>
        <CountUp
        end={46}
        enableScrollSpy={true}
        scrollSpyOnce={false}
        scrollSpyDelay={0}
        duration={5}
        />
        +
        </div>
        <div className={classes.cardsubHeading}>{b3?.title3}</div>
        <Grid style={{ fontWeight: "bold" }}>{b3?.desc3}</Grid>
        </Grid>
        </Grid>
        </div>
        </div> */}
{/* <div
          className={classes.carousel_event}
          style={{
            overflow: "hidden",
            maxHeight: "1000px",
            backgroundColor: "#221857",
            width: isSmallScreen ? "100%" : "40vw",
            marginLeft: isSmallScreen ? "0px" : "4vw",
            marginTop: isSmallScreen ? "-5vh" : "-10vh",
          }} // Adjust the maxHeight as needed
          >
          <Carousels
            indicators={true}
            navButtonsAlwaysVisible={isSmallScreen ? false : true}
            fullHeightHover={false}
            animation={"slide"}
            swipe={true}
            stopAutoPlayOnHover={true}
            navButtonsProps={{
              style: {
                borderRadius: "50%",
                backgroundColor: "#6A58c6",
                height: "50px",
                color: "black",
                width: "50px",
                marginTop: "25px",
                "&:hover": {
                  transform: "scale(1.1)",
                },
              },
            }}
            >
            {b4?.map((item, index) => (
              <div
                key={item.id}
                className={classes.mainTestimonial}
                style={{ height: "100%", overflow: "hidden" }}
                >
                <Grid container>
                  <Grid item sm={3}>
                    <img
                      src={img4}
                      alt={item.name} // Add alt text for accessibility
                      style={{
                        marginLeft: isSmallScreen ? "10vw" : "0vw",
                      }}
                      className={classes.imageTestimonialDesign}
                      />
                      </Grid>
                      <Grid item sm={9}>
                    <Typography
                    style={{
                      color: "white",
                        fontSize: "20px",
                        fontWeight: "500",
                        textAlign: "left",
                        marginLeft: isSmallScreen ? "10vw" : "5px",
                      }}
                      >
                      {item?.testimonial}
                      </Typography>
                      </Grid>
                      
                      <Grid
                      item
                      sm={2.3}
                    style={{
                      paddingTop: "4vh",
                      paddingLeft: "5vw",
                    }}
                    >
                    <img
                    src={index === 0 ? img1 : index === 1 ? img2 : img3}
                    alt={item.name} // Add alt text for accessibility
                    className={classes.imageTestimonial}
                    style={{
                      marginLeft: isSmallScreen ? "4rem" : "",
                      }}
                      />
                      </Grid>
                      <Grid
                      item
                      xs={12}
                      sm={4}
                      style={{
                        paddingTop: isSmallScreen ? "1vh" : "12vh",
                        paddingLeft: "5px",
                    }}
                  >
                    <Typography
                      style={{
                        color: "white",
                        fontWeight: "700",
                        fontSize: "22px",
                        textAlign: isSmallScreen ? "center" : "left",
                      }}
                    >
                    {item?.name}
                    </Typography>
                    </Grid>
                    </Grid>
              </div>
            ))}
            </Carousels>
            </div>   */}
{/* <div className={classes.mainVideo}>
              {b1 ? (
                <>
                  <Video link={b1?.videoLink} />
                </>
              ) : null}
            </div> */}